import authReducer from "./Reducers/authReducer";
import categoryReducer from "./Reducers/categoryReducer";
import productReducer from "./Reducers/productReducer";
import OrderReducer from "./Reducers/OrderReducer";
import dashboardIndexReducer from "./Reducers/dashboardIndexReducer";
import blogReducer from "./Reducers/blogReducer";
import videoReducer from "./Reducers/videoReducer";
import careerReducer from "./Reducers/careerReducer";
import awardReducer  from "./Reducers/awardReducer";
import eventReducer  from "./Reducers/eventReducer";
import  newsReducer from "./Reducers/newsReducer";
import  specialityReducer  from "./Reducers/specialityReducer";
const rootReducer = {
  auth: authReducer,
  category: categoryReducer,
  product: productReducer,
  award: awardReducer,
  event: eventReducer,
  news: newsReducer,
  speciality: specialityReducer,

  order: OrderReducer,
  dashboardIndex: dashboardIndexReducer,
  blog: blogReducer,
  video: videoReducer,
  career: careerReducer,

};
export default rootReducer;
